import { ResourceType } from '../enums/ResourceType';

/**
 * @group Types
 * 
 * @summary
 * <blockquote>Array of all ResourceType values for iteration and validation</blockquote>
 * 
 * @example
 * ```typescript
 * import { RESOURCE_TYPES } from './RESOURCE_TYPES';
 * 
 * // Check if a value is a valid resource type
 * const isValidType = RESOURCE_TYPES.includes('page');
 * 
 * // Iterate over all resource types
 * RESOURCE_TYPES.forEach(type => {
 *   console.log(`Processing ${type}`);
 * });
 * ```
 */
export const RESOURCE_TYPES = [
  ResourceType.DATABASE,
  ResourceType.ACTION,
  ResourceType.ROUTE,
  ResourceType.PAGE,
  ResourceType.MODULE,
  ResourceType.UI
] as const;
